import LanguageReducer from './LanguageReducer';
import AlertReducer from './AlertReducer';

export const sharedJavascriptReducers = {
    language: LanguageReducer,
    alert: AlertReducer,
};
